import React from 'react';
import { philosophy } from '../mock';

const PhilosophySection = () => {
  return (
    <section id="filosofia" className="py-32 bg-[#F2F4F0]">
      <div className="container mx-auto px-6 sm:px-12 lg:px-20">
        <div className="grid lg:grid-cols-2 gap-16 lg:gap-24 items-stretch">
          {/* Image Side */}
          <div className="relative h-full min-h-[420px]">
            <img
              src="https://images.unsplash.com/photo-1759262151080-e05ba1c6294f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzV8MHwxfHNlYXJjaHwzfHxhZXN0aGV0aWMlMjBtZWRpY2luZSUyMGNsaW5pYyUyMGx1eHVyeSUyMGxpZmVzdHlsZXxlbnwwfHx8fDE3ODQ2ODkwMzR8MA&ixlib=rb-4.1.0&q=85"
              alt="Filosofía Qara"
              className="absolute inset-0 w-full h-full object-cover"
            />
          </div>

          {/* Content Side */}
          <div className="flex flex-col justify-center">
            <p className="text-xs font-medium uppercase tracking-[0.3em] text-gold-700 mb-6">
              {philosophy.subtitle}
            </p>
            <h2 className="text-4xl sm:text-5xl font-serif font-light text-gray-900 mb-8">
              {philosophy.title}
            </h2>
            <p className="text-lg text-gray-700 leading-relaxed font-light mb-12">
              {philosophy.content}
            </p>

            {/* Values as elegant list */}
            <div className="border-t border-[#D8DAD3]">
              {philosophy.values.map((value, index) => (
                <div
                  key={value.title}
                  data-testid={`philosophy-value-${index}`}
                  className="flex items-start gap-8 py-6 border-b border-[#D8DAD3]"
                >
                  <span className="text-2xl font-serif text-gold-600 leading-none pt-1">
                    {String(index + 1).padStart(2, '0')}
                  </span>
                  <div>
                    <h3 className="text-xl font-serif font-normal text-gray-900 mb-1">
                      {value.title}
                    </h3>
                    <p className="text-gray-600 leading-relaxed font-light text-sm">
                      {value.description}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PhilosophySection;
